import { type ReactNode, type ReactElement } from 'react'
import { AddUserButton, type AddUserButtonProps } from 'app/components/user'
import { type TDrawerProps, TDrawer } from 'app/components/terros'
import { TButton } from 'app/components/buttons'
import { isTrue } from '@terros/common'
import { type PickUserSearchProps, PickUserSearch } from './PickUserSearch'

export type PickUserDrawerProps = {
  isOpen: boolean
  close: VoidFunction
  allowMultiple?: boolean
  drawerProps?: Omit<TDrawerProps, 'opened' | 'onClose'>
  canAddUser?: boolean
  headerButtonProps?: AddUserButtonProps
  doneButton?: boolean
} & PickUserSearchProps

export const PickUserDrawer = ({
  isOpen,
  close,
  onSelect,
  allowMultiple,
  drawerProps,
  headerButtonProps: addUserButtonProps,
  canAddUser,
  doneButton,
  ...searchProps
}: PickUserDrawerProps): ReactElement => {
  return (
    <TDrawer
      opened={isOpen}
      position='right'
      size='lg'
      title='Select User'
      headerActions={
        <HeaderActions
          canAddUser={canAddUser}
          close={close}
          doneButton={doneButton}
          headerButtonProps={addUserButtonProps}
        />
      }
      onClose={close}
      {...drawerProps}
    >
      <PickUserSearch
        {...searchProps}
        onSelect={async (user) => {
          await onSelect(user)
          if (!allowMultiple) {
            close()
          }
        }}
      />
    </TDrawer>
  )
}

type HeaderActionsProps = {
  canAddUser: boolean | undefined
  headerButtonProps: AddUserButtonProps | undefined
  close: VoidFunction
  doneButton?: boolean
}
const HeaderActions = ({ canAddUser, headerButtonProps, close, doneButton }: HeaderActionsProps): ReactNode => {
  if (isTrue(canAddUser)) {
    return <AddUserButton variant='secondary' {...headerButtonProps} />
  }
  if (isTrue(doneButton)) {
    return (
      <TButton {...headerButtonProps} variant='secondary' onClick={close}>
        Done
      </TButton>
    )
  }
  return undefined
}
